import React, { useEffect, useRef, useState } from 'react';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import SettingsMenu from '../SettingsMenu'
import AuthService, { useAuthContext } from "../../../services/AuthService";
import styles from './styles';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Account = (props) => {
    const { classes } = props;
    const { history } = props;

    console.log("================================== Account ======================================");

    // Get Auth Context
    const auth = useAuthContext();

    // Component States
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [previousPassword, setPreviousPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const loadAccount = () => {
        AuthService.GetAccount()
            .then(function (response) {
                let account = response.data;
                setUsername(account["username"]);
                setEmail(account["email"]);
            })
    }

    // Setup Component
    useEffect(() => {
        if (auth.state.isAuthenticated) {
            loadAccount();
        }
    }, []);

    const handlePasswordChange = () => {
        if (newPassword !== confirmPassword) {
            setSnackbarMessage("New passwords do not match.");
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            return;
        }

        AuthService.ChangePassword(previousPassword, newPassword)
            .then(() => {
                setSnackbarMessage("Password changed successfully.");
                setSnackbarSeverity('success');
                setOpenSnackbar(true);
                setPreviousPassword('');
                setNewPassword('');
                setConfirmPassword('');
            })
            .catch((error) => {
                setSnackbarMessage(error.response.data.detail || "An error occurred.");
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
            });
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
        <div className={classes.root}>
            <main className={classes.main}>
                <Container maxWidth="md" className={classes.container}>
                    <Grid container spacing={2}>
                        <Grid item sm={4}>
                            <SettingsMenu page="account" />
                        </Grid>
                        <Grid item sm={8}>
                            <Typography variant="h6" gutterBottom>
                                Account Settings
                            </Typography>
                            <Divider />
                            <div className={classes.inputContainer}>
                                <TextField
                                    label="Username"
                                    placeholder="Username"
                                    helperText=""
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    value={username}
                                    disabled
                                />
                                <TextField
                                    label="Email"
                                    placeholder="Email"
                                    helperText=""
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <TextField
                                    label="Previous Password"
                                    placeholder="Enter previous password"
                                    helperText=""
                                    fullWidth
                                    margin="normal"
                                    type="password"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    value={previousPassword}
                                    onChange={(e) => setPreviousPassword(e.target.value)}
                                />
                                <TextField
                                    label="New Password"
                                    placeholder="Enter new password"
                                    helperText=""
                                    fullWidth
                                    margin="normal"
                                    type="password"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <TextField
                                    label="Confirm New Password"
                                    placeholder="Confirm new password"
                                    helperText=""
                                    fullWidth
                                    margin="normal"
                                    type="password"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </div>
                            <div className={classes.buttonContainer}>
                                <Button variant="outlined" color="primary" onClick={handlePasswordChange}>Change Password</Button>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </main>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default withStyles(styles)(Account);